<template>
	<div>
		<v-virtual-scroll
			v-if="items.length"
			:items="items"
			height="300"
			item-height="45"
		>
			<template v-slot:default="{ item }">
				<task-menu-item
					:isActive="
						activeList.name === 'tag' && activeList.id === item.id
					"
					@setAciveList="
						$emit('setActiveList', { name: 'tag', id: item.id })
					"
					:id="item.id"
					:color="item.color"
					:key="item.id"
					:listName="item.name"
					:numberOfTasks="item.unfinished_tasks_count || 0"
					type="tag"
					:tag="item"
				/>
			</template>
		</v-virtual-scroll>

		<div v-if="!items.length" class="d-flex flex-column align-center">
			Brak tagów
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";

import TaskMenuItem from "@/components/tasks/TaskMenuItem";

export default {
	components: {
		TaskMenuItem,
	},

	props: {
		activeList: {
			type: Object,
		},
	},

	computed: {
		...mapGetters({
			items: "tasks/tags",
		}),
	},
};
</script>

<style scoped lang="scss">
.search {
	max-width: 250px;
	max-height: 32px !important;

	* {
		max-height: 32px !important;
	}
}
</style>
